<template>
  <section class="top-chat-msg" v-if="chatMsgRecommend?.msg_id">
    <div class="top-chat-msg-content">
      <span class="theme-color">{{ $t('host.k_512001') }}</span>
      <span v-html="chatMsgRecommend.msg_content"></span>
    </div>
    <vh-button class="theme-color" type="text" @click="cancelRecommend" v-if="roleName != 2">
      {{ $t('host.k_512002') }}
    </vh-button>
    <i v-else class="vh-iconfont vh-line-close" @click="closeRecommend"></i>
  </section>
</template>
<script>
  import { useChatServer } from 'middle-domain';
  export default {
    computed: {
      // 当前用户角色 1-主持人 2-观众(发起端没有观众) 3-助理；4-嘉宾（互动直播才有嘉宾）
      roleName() {
        return this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name;
      },
      chatMsgRecommend() {
        return this.$domainStore.state.chatServer.chatMsgRecommend;
      }
    },
    methods: {
      cancelRecommend() {
        useChatServer()
          .handleRecommendMsg({
            webinar_id: this.$domainStore.state.roomBaseServer.watchInitData.webinar.id,
            msg_id: this.chatMsgRecommend.msg_id,
            recommend_status: 0
          })
          .then(res => {
            if (res.code == 200) {
              this.$vhMessage.success(this.$t('host.k_512003'));
            }
          });
      },
      closeRecommend() {
        this.$domainStore.state.chatServer.chatMsgRecommend = null;
      }
    }
  };
</script>
<style lang="less" scoped>
  .top-chat-msg {
    background: var(--theme-notice-column-bg);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 10px;
    line-height: 24px;
    font-size: 14px;
    display: flex;
    z-index: 10;
    &-content {
      flex: 1;
      color: var(--theme-notice-column-text);
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 显示的行数 */
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: 48px;
      img {
        height: 40px !important;
        width: 40px !important;
      }
    }
    .theme-color {
      color: var(--theme-color);
    }
    .vh-line-close {
      color: var(--theme-notice-column-text);
      cursor: pointer;
    }
  }
</style>
